import { Position, Toaster, Intent } from "@blueprintjs/core";
 
/** Singleton toaster instance. Create separate instances for different options. */
export const NetworkToaster = Toaster.create({
    position: Position.TOP,
});